import {
  LEAD_PHASE_LABELS,
  LEGACY_LEAD_PHASE_LABELS,
  JOBCARD_PHASE_LABELS,
  TICKET_STATUS_LABELS,
} from "../lib/enums";

const COLORS = {
  // ---- Lead phases (12-step funnel) ----
  lead_logged: "border-slate-400/40 text-slate-200 bg-slate-500/10",
  initial_contact: "border-blue-500/40 text-blue-300 bg-blue-500/10",
  callout_quote: "border-cyan-500/40 text-cyan-300 bg-cyan-500/10",
  callout_scheduled: "border-sky-500/40 text-sky-300 bg-sky-500/10",
  design_quote: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  estimate_sent: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  estimate_followup: "border-orange-500/40 text-orange-300 bg-orange-500/10",
  so_sent: "border-yellow-500/40 text-yellow-300 bg-yellow-500/10",
  so_followup: "border-yellow-400/40 text-yellow-200 bg-yellow-400/10",
  lead_paused: "border-indigo-500/40 text-indigo-300 bg-indigo-500/10",
  // ---- Legacy lead phases ----
  new_lead: "border-slate-400/40 text-slate-200 bg-slate-500/10",
  meeting_scheduled: "border-sky-500/40 text-sky-300 bg-sky-500/10",
  design_in_progress: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  quote_in_progress: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  quote_sent: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  sales_order_sent: "border-yellow-500/40 text-yellow-300 bg-yellow-500/10",
  future_prospect: "border-indigo-500/40 text-indigo-300 bg-indigo-500/10",
  new: "border-slate-400/40 text-slate-200 bg-slate-500/10",
  contacted: "border-blue-500/40 text-blue-300 bg-blue-500/10",
  qualified: "border-cyan-500/40 text-cyan-300 bg-cyan-500/10",
  proposal: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  // ---- Job-card phases (13 + legacy) ----
  created: "border-slate-400/40 text-slate-200 bg-slate-500/10",
  picking: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  ready: "border-cyan-500/40 text-cyan-300 bg-cyan-500/10",
  scheduled: "border-blue-500/40 text-blue-300 bg-blue-500/10",
  in_progress: "border-cyan-500/40 text-cyan-300 bg-cyan-500/10",
  paused: "border-indigo-500/40 text-indigo-300 bg-indigo-500/10",
  on_site_complete: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  complete: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  signed_off: "border-violet-400/40 text-violet-200 bg-violet-500/10",
  ready_to_invoice: "border-yellow-500/40 text-yellow-300 bg-yellow-500/10",
  invoice_sent: "border-yellow-400/40 text-yellow-200 bg-yellow-400/10",
  paid: "border-emerald-500/60 text-emerald-200 bg-emerald-500/20",
  closed: "border-slate-500/40 text-slate-300 bg-slate-500/10",
  cancelled: "border-rose-500/40 text-rose-300 bg-rose-500/10",
  quote_client: "border-rose-500/50 text-rose-300 bg-rose-500/10", // orphan/legacy from AppSheet
  // ---- Ticket statuses (9) ----
  logged: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  pending_assignment: "border-orange-500/40 text-orange-300 bg-orange-500/10",
  assigned: "border-cyan-500/40 text-cyan-300 bg-cyan-500/10",
  escalated: "border-rose-500/50 text-rose-300 bg-rose-500/10",
  job_card_issued: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  resolved_via_jc: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  resolved_external: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  resolved_virtually: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  open: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  resolved: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  // ---- Customer status ----
  active: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  inactive: "border-slate-500/40 text-slate-300 bg-slate-500/10",
  lead: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  lost: "border-rose-500/40 text-rose-300 bg-rose-500/10",
  won: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
};

const ALL_LABELS = {
  ...LEAD_PHASE_LABELS,
  ...LEGACY_LEAD_PHASE_LABELS,
  ...JOBCARD_PHASE_LABELS,
  ...TICKET_STATUS_LABELS,
  // customer
  active: "Active",
  inactive: "Inactive",
  lead: "Lead",
  closed: "Closed",
  lost: "Lost",
};

export default function PhaseChip({ value, className = "" }) {
  const cls = COLORS[value] || "border-white/15 text-white/70 bg-white/5";
  const label = ALL_LABELS[value] || (value || "—").replaceAll("_", " ");
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-[0.12em] border ${cls} ${className}`}
    >
      {label}
    </span>
  );
}
